module.exports = __webpack_public_path__ + "static/media/newQUICK.cbd2351a.svg";